import { IResourceType } from '../types/IResourceType'
import { IResourceTypeIcon } from '../types/IResourceTypeIcon'
import { IResourceTypeComponents } from '../types/IResourceTypeComponents'
import { AccessLevel } from '../types/AccessLevel'
import { Sample } from './Sample'
import { AlreadyInCartType } from '../types/helperTypes'
import { ICartItem } from '../types/ICartItem'
import { IResource } from '../types/IResource'
import { RESOURCE_TYPE_NAMES } from 'utils'

export class ApplicationRoleType implements IResourceType {
    name = RESOURCE_TYPE_NAMES.APPLICATION_ROLES

    route = '/applicationRoles'

    title = 'Common_ApplicationRole'

    access: AccessLevel = {
        page: 'ITShop-ApplicationRoles-Page',
    }

    icon: IResourceTypeIcon = {
        small: 'ApplicationRolesSmall',
        large: 'ApplicationRolesLarge',
    }

    manageAccessComponents: IResourceTypeComponents = {
        cardComponent: Sample,

        rowComponent: Sample,

        detailComponent: Sample,
    }

    requestAccessComponents: IResourceTypeComponents = {
        cardComponent: Sample,

        rowComponent: Sample,

        detailComponent: Sample,
    }

    readonly cartComponent = null

    alreadyInCart: AlreadyInCartType = (
        cartItems: ICartItem[],
        resource: IResource,
    ) =>
        cartItems.find((c) => c.requestableResourceId === resource.id) !==
        undefined

    filters = []

    attributes = []
}
